import { PropsWithChildren } from "react";
import PageHeading from "@/components/ui/PageHeading.tsx";
import AbsoluteBackground from "@/components/ui/AbsoluteBackground.tsx";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";

export default function DiplomaRequestMobileLayout({
  children,
}: PropsWithChildren<NonNullable<unknown>>) {
  return (
    <>
      <AbsoluteBackground className="bg-[--secondary]" />

      <DashboardContentLayout className="px-0 pb-0 bg-[--secondary]">
        <PageHeading
          title="Diploma request"
          className="px-4"
          // titleClassName={"!text-secondary-dark"}
          // subtitleClassName={"!text-light"}
          subtitle={
            "Book the meeting, do the final assessment \n" +
            "and obtain your diploma"
          }
        />

        <div className="flex flex-col w-full relative h-full">
          <div className="w-full flex flex-col gap-4 h-full bg-white px-6 py-[min(1.5rem,2vh)] justify-evenly">
            <div className="flex flex-col gap-1 w-full">
              <h2 className="text-xl font-semibold text-brand">
                Choose a date and time <br /> for the meeting
              </h2>

              <p className="text-base text-brand">
                A calendar invite will be sent to your email address
              </p>
            </div>

            <div className="flex flex-col gap-4 justify-between h-full items-center">
              {children}
            </div>
          </div>
        </div>
      </DashboardContentLayout>
    </>
  );
}
